"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildNow = exports.overrideTZ = exports.dateWeekBefore = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
function dateWeekBefore() {
    return (0, moment_timezone_1.default)().subtract(7, 'd').toISOString();
}
exports.dateWeekBefore = dateWeekBefore;
function overrideTZ(date, TZ = 'Europe/London') {
    const timeFormat = 'YYYY-MM-DDTHH:mm:ss';
    const time = moment_timezone_1.default.parseZone(date);
    return moment_timezone_1.default.tz(time.format(timeFormat), TZ);
}
exports.overrideTZ = overrideTZ;
function buildNow(stubISOString, envVarName = 'STUB_TIME') {
    var _a;
    const envStubTime = (_a = global.env) === null || _a === void 0 ? void 0 : _a[envVarName];
    return () => {
        const stubTime = stubISOString || envStubTime;
        if (stubTime) {
            return (0, moment_timezone_1.default)(stubTime);
        }
        else {
            return (0, moment_timezone_1.default)();
        }
    };
}
exports.buildNow = buildNow;
